<template>
  <div class="h-download">
    <el-row>
      <el-col :span="5">
        <img
          v-if="languageInfo.icon"
          class="logo"
          v-lazy="$utils.returnImgUrl(languageInfo.icon)"
          fit="contain"
          @click="btnCilck"
          alt=""
        />
      </el-col>

      <el-col :span="19">
        <div class="fl downtxt" :class="isL375 ? 'l375' : ''" @click="btnCilck">
          <div class="h-txt title">{{ languageInfo.title }}</div>
          <div class="h-txt">{{ languageInfo.content }}</div>
        </div>
        <div class="fr">
          <div class="download" @click="btnCilck">
            {{ languageInfo.btuText }}
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="close-down" @click="closeDownload">
      <img v-lazy="Close" fit="contain" alt="" />
    </div>
  </div>
</template>

<script>
import Close from "@/assets/close.png";
import { isMobile } from "@/lobby_common/utils/utils.js";
import { goJoinEvent } from "@/lobby_common/utils/utils.js";
export default {
  name: "h-header-download",
  props: {
    contentObj: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      Close,
      downloadObj: {},
      languageInfo: {},
      userType: "ios",
      cur_invite_code: "",
      isL375: window.innerWidth < 375,
    };
  },
  watch: {
    contentObj: {
      handler: function (val) {
        if (val) {
          this.downloadObj = this.contentObj;
          this.languageInfo = this.downloadObj.language ? { ...this.downloadObj.language } : {};
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    this.init();
  },
  computed: {
    lang() {
      return this.$store.getters.getLang;
    },
    ios() {
      const obj = {
        name: "down.ios",
        link: this.$store.getters.getPacketConfig?.site?.ios_download,
        id: 1,
      };
      return obj;
    },
    andriod() {
      const obj = {
        name: "down.andriod",
        link: this.$store.getters.getPacketConfig?.site?.android_download,
        id: 2,
      };
      return obj;
    },
  },
  methods: {
    init() {
      const old_uid = localStorage.getItem("inviteCode");
      const user_ic = JSON.parse(localStorage.getItem("USER_DATA"));
      if (user_ic && user_ic.inviteCode) {
        this.cur_invite_code = user_ic.inviteCode;
      } else {
        this.cur_invite_code = JSON.parse(old_uid);
      }
      const system = this.systemCheack() || "Android";
      if (system === "Android") {
        this.userType = "andriod";
      }
      if (system === "ios") {
        this.userType = "ios";
      }
    },
    btnCilck() {
      this.$eventPost("H5_topnavigation_click");
      // 除了多款游戏其他跳转
      goJoinEvent(this.contentObj.jump);
    },
    closeDownload() {
      this.$eventPost("H5_topnavigation_close");
      this.$emit("closeDownload");
    },
    downloadApp() {
      // 新逻辑   跳下载页， 下载页还没做
      // let url = this.andriod.link;
      // let id = this.andriod.id;
      // if (this.userType === "ios") {
      //   url = this.ios.link;
      //   id = this.ios.id;
      // }
      // const cur_url = this.codeFun(url);
      // // const system = this.systemCheack() || "Android";
      // // iso 根据jumper=true延迟3秒打开另外一个链接
      // if (this.userType === "ios" && cur_url.includes("jumper=true")) {
      //   if (isMobile()) {
      //     window.open(cur_url, "_self");
      //   } else {
      //     window.open(cur_url, "_blank");
      //   }
      // } else {
      //   if (isMobile()) {
      //     window.open(cur_url, "_self");
      //   } else {
      //     window.open(cur_url, "_blank");
      //   }
      // }
    },
    // 检查系统是安卓还是ios
    systemCheack() {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // 安卓机！
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端.
      if (isAndroid) {
        return "Android";
      }
      if (isIOS) {
        return "ios";
      }
    },
    codeFun(url) {
      if (!this.cur_invite_code) {
        return url;
      } else {
        if (url.indexOf("?") !== -1) {
          return url + "&uid=" + this.cur_invite_code;
        } else {
          return url + "?uid=" + this.cur_invite_code;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.h-download {
  padding: 0px 10px;
  box-sizing: border-box;
  font-size: 12px;
  color: var(--font-color-100);
  height: 40px;
  background: var(--background-100);
}

.el-row,
.el-col {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo {
  width: 30px;
  height: 30px;
  margin: 0 0 0 25px;
  overflow: hidden;
}
.download {
  text-align: center;
  height: 25px;
  line-height: 25px;
  border-radius: 20px;
  padding: 0 15px;
  @include buttonPrimary;
}
.h-txt {
  line-height: 15px;
  color: var(--font-color-100);
  max-width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  &.title {
    font-weight: bold;
    color: var(--font-color-1000);
  }
}
.l375 .h-txt {
  width: 150px;
}
.close-down {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 12px;
  left: 10px;
  cursor: pointer;
  img {
    width: 100%;
    display: block;
  }
}
</style>
